<template>
  <section class="section">
    <div class="title is-4">{{ $t("edit template") }}</div>
    <div class="form">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="template.name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("template engine") }}</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="template.template_engine">
                  <option value="modul">{{ $t("modul") }}</option>
                  <option value="handlebars">{{ $t("handlebars") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("use as default?") }}</label>
            <div class="control">
              <input
                class="is-checkradio"
                type="checkbox"
                id="chk_use_as_default"
                name="chk_use_as_default"
                v-model="template.use_as_default"
              />
              <label for="chk_use_as_default">
                {{ $t("use as default?") }}
              </label>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="field">
            <label class="label">&nbsp;</label>
            <div class="control">
              <button class="button is-primary is-rounded" @click="save">
                <span class="icon">
                  <i class="fa fa-save"></i>
                </span>
                <span>{{ $t("save") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="">
      <span
        class="button is-pulled-right is-info is-small is-rounded"
        @click="preview"
      >
        <span class="icon"><i class="fa fa-eye"></i></span>
        <span>{{ $t("preview") }}</span>
      </span>
      <div class="title is-5 mt-5">
        {{ $t("html code") }}
      </div>
      <vue-monaco-editor
        v-model:value="template.message"
        theme="vs-dark"
        language="html"
        :options="{
          automaticLayout: true,
          formatOnType: true,
          formatOnPaste: true,
          tabSize: 2,
          scrollBeyondLastLine: false,
          folding: true,
          bracketPairColorization: true,
          autoClosingBrackets: 'always',
          autoIndent: 'full',
        }"
        style="height: 500px"
      />
    </div>
    <!-- <pre>{{ template }}</pre> -->
  </section>
</template>

<script>
import { warning_message, success_message, get, post } from "@/utils";
import { template } from "lodash";
import { VueMonacoEditor } from "@guolao/vue-monaco-editor";

export default {
  name: "LandingIndex",
  components: {
    VueMonacoEditor,
  },
  data() {
    return {
      template: {
        name: "",
        message: "",
        uuid: "",
        arguments: [],
        template_engine: "",
        use_as_default: false,
      },
    };
  },
  methods: {
    refresh() {
      let v = this;
      v.$root.loader(true);
      get("/landing/template", { uuid: v.$route.params.uuid })
        .then((response) => {
          // v.template = response;
          if (response.name) v.template.name = response.name;
          if (response.uuid) v.template.uuid = response.uuid;
          if (response.settings.message)
            v.template.message = response.settings.message;
          if (response.settings.template_engine)
            v.template.template_engine = response.settings.template_engine;
          if (response.settings.use_as_default)
            v.template.use_as_default = response.settings.use_as_default;
        })
        .catch((error) => {
          warning_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    preview() {
      /** show html in new window */
      let v = this;
      if (!v.template.message) {
        warning_message(v.$t("html code is empty"));
        return;
      } else {
        let html = v.template.message;
        let newWindow = window.open("", "_blank");
        newWindow.document.write(html);
        newWindow.document.close();
      }
    },
    save() {
      let v = this;
      v.$root.loader(true);
      post("/landing/template", v.template)
        .then((response) => {
          success_message(v.$t("template saved successfully"));
        })
        .catch((error) => {
          console.error(error);
          warning_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
  },
  mounted() {
    this.refresh();
  },
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
